import { render, staticRenderFns } from "./offrecord.vue?vue&type=template&id=b5e17bea&scoped=true"
import script from "./offrecord.vue?vue&type=script&lang=js"
export * from "./offrecord.vue?vue&type=script&lang=js"
import style0 from "./offrecord.vue?vue&type=style&index=0&id=b5e17bea&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5e17bea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/deduct_saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b5e17bea')) {
      api.createRecord('b5e17bea', component.options)
    } else {
      api.reload('b5e17bea', component.options)
    }
    module.hot.accept("./offrecord.vue?vue&type=template&id=b5e17bea&scoped=true", function () {
      api.rerender('b5e17bea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/offrecord.vue"
export default component.exports